/**
 * Garde de route basée sur le profil d'accès (matrice DFS).
 * accessProfile dérivé de access_level du rôle référentiel.
 */
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAuth, type AccessProfile } from "../../context/AuthContext";

interface ProtectedRouteProps {
  allowedRoles?: AccessProfile[];
  children: ReactNode;
}

const PROFILE_LEVEL: Record<AccessProfile, number> = {
  admin: 100,
  manager: 50,
  expert: 10,
};

export function ProtectedRoute({ allowedRoles, children }: ProtectedRouteProps) {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: 24 }}>{t("loading")}</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const min = Math.min(...allowedRoles.map((r) => PROFILE_LEVEL[r]));
    if ((user.accessLevel ?? 0) < min) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
